import Button from "../ui_components/button/button";
import {
    Modal,
    ModalActions as ModalActionsE,
    ModalContent,
    ModalHeader as ModalHeaderE,
    ModalProps,
} from "../ui_components/modal";
import PageDimmer from "../ui_components/dimmer/PageDimmer";
import React from "react";
import styled, { css } from "styled-components";
import { breakpoints, theme } from "../theme";
import PopupImg from "../assets/icons/red_warning.svg";

const noop = () => {
    /* ignore */
};

export interface CantConnectModalProps
    extends Pick<
        ModalProps,
        | "uiActive"
        | "uiOnRequestClose"
        | "className"
        | "uiOnClose"
        | "uiTransitionTimeout"
        | "uiCloseOnEsc"
        | "uiCloseOnOutsideClick"
    > {
    /**
     * Modal header
     */
    uiHeader?: string;
    /**
     * Accept button label
     */
    uiAcceptLabel?: string | false;
    /**
     * Close modal when pressing Esc
     * @default true
     */
    uiCloseOnEsc?: boolean;
    /**
     * Close modal on outside click
     * @default true
     */
    uiCloseOnOutsideClick?: boolean;
    /**
     * Class name
     */
    className?: string;
    /**
     * Child
     */
    children?: React.ReactNode;
    /**
     * Confirmation callback
     */
    uiOnConfirm(res?: unknown): void;

    /**
     * Edit Work Order condition
     */
    workOrderEditMode?: boolean;

    /**
     * Cancel editing Work Order
     */
    cancelEditing?(): void;
}

const CantConnectContent = styled(ModalContent)`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    color: ${theme.colors.grayRGBA};
`;

const StyledModal = styled(Modal)`
    max-width: 500px;
    border-radius: 0.5rem;
    border: solid ${theme.colors.grayRGBA} 1px;
    ${breakpoints.down(
        "sm",
        css`
            max-width: 90%;
        `
    )};
`;

const ModalHeader = styled(ModalHeaderE)`
    color: black;
    border-bottom: none;
    padding-bottom: 0.25rem;
`;

const ModalActions = styled(ModalActionsE)`
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    justify-content: flex-end;
    padding: 0.7rem 1rem;
    border-top: none;
    margin-top: 60px;
`;

const BasicButton = styled(Button)`
    // width: 130px;
    box-shadow: none;
    border: 1px solid #c6c6c6;
    border-radius: 0.5em;
    display: block;
`;

const ConfirmButton = styled(BasicButton)`
    border-radius: 5px;
    // width: 100px;
    box-shadow: none;
    line-height: 0.6rem;
    &:hover {
        background: #c6c6c6;
    }
    margin-left: ${(props) =>
        props.className === "pop-up" ? "auto" : "initial"};
`;

const CancelButton = styled(BasicButton)`
    border-radius: 5px;
    // width: 100px;
    box-shadow: none;
    line-height: 0.6rem;
    background-color: #ffffffff;
    color: #222222;
    border: none;
    &:hover {
        background: #eeeeee;
    }
`;

/**
 * Simple confirmation modal
 */
export const CantConnectModal: React.FC<CantConnectModalProps> = (props) => {
    const leftButtonAction = props.uiOnRequestClose
    const rightButtonAction = props.uiOnConfirm
    return (
        <StyledModal
            className={props.className}
            uiActive={props.uiActive}
            uiOnRequestClose={noop}
            uiDefaultSizes={false}
            uiOnClose={props.uiOnClose}
            uiTransitionTimeout={props.uiTransitionTimeout}
            uiCloseOnOutsideClick={props.uiCloseOnOutsideClick}
            uiCloseOnEsc={props.uiCloseOnEsc}
        >
            {props.uiAcceptLabel === "Setup" &&
                props.uiHeader === "Setup Needed" && <PageDimmer uiActive />}
            <ModalHeader><PopupImg/> {props.uiHeader}</ModalHeader>
            <CantConnectContent>{props.children}</CantConnectContent>
            <ModalActions>
                {props.uiAcceptLabel && (
                    <CancelButton
                        id="confirm"
                        uiColor="primary"
                        onClick={leftButtonAction}
                        className={props.className}
                    >
                        Close
                    </CancelButton>
                )}
                {props.uiAcceptLabel && (
                    <ConfirmButton
                        id="confirm"
                        uiColor="primary"
                        onClick={rightButtonAction}
                        className={props.className}
                    >
                        Retry
                    </ConfirmButton>
                )}
            </ModalActions>
        </StyledModal>
    );
};

CantConnectModal.defaultProps = {
    uiHeader: "Warning!",
    uiAcceptLabel: "Close",
};
